module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('h4', {
    staticClass: "section1"
  }, [_c('i', [_vm._v("I offer my sincerest thanks:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_top"
  }, [_vm._v("To my cousin and friend Brent Bingham who taught me how to rock climb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dean Blanchard of Wharton, who gave me a chance to prove I could do the work and be employable, and the Wharton School for making an investment in me that paid off for us both.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my brother David, my first best friend whom I miss to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the many family and friends who did not let me give up on myself")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dr. Fernando Flores, who taught me how to think.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my Uncle Jake Garn, United States Senator and space shuttle astronaut who visited me in the hospital for forty-two days straight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To George Gilder, who taught me to listen to technology and how it changes the economy by changing the relative prices of factors of production.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To all the neighbors that day in Salt Lake City who rushed to my aid, especially Ruth Johnson, the nurse who saved my life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dr. Art Laffer, who taught me serious economics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Dr. Drew Lebby, my dear friend and trusted advisor for over thirty-five years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To James McClennen, who gave me the chance to prove I could learn to invest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my fraternity brother Kendall Oldroyd who encouraged me during graduate school during what appeared to be a futile job search, with his words, “if you were a stock, I would invest in you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Stanford and Harvard for rejecting my graduate school applications. They joined the extensive list who said, “You can’t.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 72
// module chunks = 0